<template>
  <div class="section-page container">
    <main class="card section-card about-card">
      <section class="about-section">
        <h1 class="hero-title">
          <span class="highlight">О проекте CT-map</span>
          <span class="title-divider"></span>
        </h1>

        <p class="lead body-text">
          CT-map — это современное веб-приложение, созданное для централизованного хранения и обмена
          данными компьютерной томографии образцов из различных областей науки и промышленности.
          Наш каталог позволяет организациям размещать информацию о своих КТ-данных, а заинтересованным пользователям —
          быстро находить, изучать и запрашивать доступ к нужным материалам. Мы строим мост между
          исследовательскими центрами, промышленностью и разработчиками, помогая ускорить развитие технологий КТ в России.
        </p>
      </section>

      <section class="about-section">
        <h1 class="hero-title">
          <span class="highlight">Области применения</span>
          <span class="title-divider"></span>
        </h1>

        <p class="body-text">
          CT-map находит применение в самых разных сферах. Мы создаём единое пространство для всех,
          кто работает с данными компьютерной томографии:
        </p>

        <ul class="bullet-list accent-list">
          <li v-for="(it, idx) in areas" :key="idx">
            <img :src="it.icon" :alt="it.alt" class="list-icon" aria-hidden="true" />
            <span class="li-text">{{ it.text }}</span>
          </li>
        </ul>
      </section>

      <section class="about-section">
        <h1 class="hero-title">
          <span class="highlight">Какую проблему решает проект</span>
          <span class="title-divider"></span>
        </h1>

        <p class="body-text bold-mode">Сегодня рынок КТ сталкивается с двумя основными барьерами:</p>

        <ol class="bullet-list numbered-list">
          <li><strong>Ограниченность доступа к данным</strong> — организации работают с изолированными базами. CT-map предоставляет централизованный доступ, упрощая поиск и систематизацию.</li>
          <li><strong>Сложности в обмене данными</strong> — отсутствие универсального репозитория тормозит совместные исследования. Наше приложение создаёт платформу для эффективного взаимодействия между исследователями, компаниями и разработчиками.</li>
        </ol>
      </section>

      <section class="about-section fund-section" aria-labelledby="fund-title">
        <h1 class="hero-title">
          <span class="highlight">Проект и поддержка</span>
          <span class="title-divider"></span>
        </h1>

        <div class="fund-grid">
          <div class="fund-logo">
            <img v-if="sponsorSrc" :src="sponsorSrc" alt="Логотип фонда" class="sponsor-img" />
          </div>

          <div class="fund-text">
            <p class="body-text support-note">
              Проект CT-map создан при поддержке Федерального государственного бюджетного учреждения
              «Фонд содействия развитию малых форм предприятий в научно-технической сфере» в рамках программы
              «Студенческий стартап» федерального проекта «Платформа университетского технологического предпринимательства».
            </p>
          </div>
        </div>
      </section>

      <section class="about-section">
        <h1 class="hero-title">
          <span class="highlight">Контакты</span>
          <span class="title-divider"></span>
        </h1>

        <address class="contacts body-text">
          <div>ООО "ТОМОВЕБ РЕШЕНИЯ"</div>
          <div>Email:
            <a :href="'mailto:' + email" class="mail-link">{{ email }}</a>
          </div>
          <div>Телефон: {{ phone }}</div>
          <div>Адрес: {{ address }}</div>
        </address>
      </section>
    </main>
  </div>
</template>

<script>
// импорт svg-иконок (убедитесь что файлы лежат в src/assets/icons/)
import codeIcon from '@/assets/icons/code.svg'
import gearIcon from '@/assets/icons/gear.svg'
import graduateIcon from '@/assets/icons/graduate.svg'
import magnifierIcon from '@/assets/icons/magnifier.svg'

export default {
  name: 'AboutView',
  data() {
    return {
      // логотип фонда (png) — положите в src/assets/fund_logo.png
      sponsorSrc: require('@/assets/fund_logo.png'),
      email: 'tomowebsolutions@yandex.ru',
      phone: '+7 (926) 524-78-56',
      address: 'г. Москва, Ленинские горы, д. 1, стр. 77',

      // список для блока "Области применения" с иконками
      areas: [
        { text: 'Контроль качества продукции', icon: magnifierIcon, alt: 'иконка контроля' },
        { text: 'Реверс-инжиниринг и разработка новых изделий', icon: gearIcon, alt: 'иконка механика' },
        { text: 'Разработка ПО для анализа данных КТ', icon: codeIcon, alt: 'иконка разработчиков' },
        { text: 'Научные исследования и образовательные проекты', icon: graduateIcon, alt: 'иконка образования' }
      ]
    }
  }
}
</script>

<style scoped>
/* ========== 🏗️ ОСНОВНЫЕ СТИЛИ 🏗️ ========== */
.container {
  max-width: 850px;
  margin: 32px auto;
  padding: 16px;
}

.section-card {
  padding: 32px;
  border-radius: 16px;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* ========== 🖋️ ТИПОГРАФИКА 🖋️ ========== */
.hero-title {
  font-size: 28px;
  margin: 0 0 24px;
  color: var(--text-primary);
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.2;
  text-align: left; /* Заголовки теперь слева */
}

.hero-title .highlight {
  color: var(--accent);
}

/* ✨ Новый градиентный разделитель под заголовком */
.title-divider {
  display: block;
  width: 100px;
  height: 3px;
  margin-top: 12px;
  background: linear-gradient(90deg, var(--accent) 0%, transparent 100%);
  border-radius: 2px;
}

.lead, .body-text {
  color: var(--text-primary);
  font-size: 17px;
  line-height: 1.8; /* Увеличена высота строки для читаемости */
  font-weight: 400;
  text-align: left; /* Выравнивание по левому краю для лучшего чтения */
  margin-bottom: 16px;
}

.bold-mode {
  font-weight: 600;
  font-size: 18px;
  color: var(--text-primary);
}

.support-note {
  color: var(--text-muted);
  font-size: 15px;
  font-weight: 400;
  line-height: 1.7;
  text-align: left;
}

/* ========== 📐 СТРУКТУРА СЕКЦИЙ 📐 ========== */
.about-section {
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid var(--border-color);
}
.about-section:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

/* ========== 📋 СПИСКИ 📋 ========== */
.bullet-list {
  margin: 24px 0 0 0;
  padding-left: 0;
  list-style-type: none;
}

.bullet-list li {
  margin-bottom: 16px;
}

/* Список с иконками */
.accent-list li {
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--text-primary);
  font-weight: 500;
  font-size: 16px;
}

/* 🎨 Применяем цвет #75E4F5 к SVG иконкам через фильтр */
.list-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  /* Этот CSS фильтр преобразует черный SVG в цвет --accent */
  filter: invert(82%) sepia(34%) saturate(1509%) hue-rotate(139deg) brightness(96%) contrast(92%);
}

/* Нумерованный список */
.numbered-list {
  counter-reset: ol-counter;
}

.numbered-list li {
  position: relative;
  padding-left: 50px;
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
}

.numbered-list li::before {
  counter-increment: ol-counter;
  content: counter(ol-counter);
  position: absolute;
  left: 0;
  top: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--accent);
  color: var(--bg-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  box-shadow: 0 0 15px var(--accent-glow);
}

.numbered-list li strong {
  font-weight: 600;
  color: var(--text-primary);
}

/* ========== 🏢 СЕКЦИЯ ФОНДА 🏢 ========== */
.fund-grid {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 24px;
  align-items: center;
}

.fund-logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sponsor-img {
  max-width: 200px;
  height: auto;
  border-radius: 8px;
  background: transparent;
}

/* ========== 📞 КОНТАКТЫ 📞 ========== */
.contacts {
  color: var(--text-muted);
  font-size: 16px;
  line-height: 2;
  text-align: left;
  font-style: normal;
}

.mail-link {
  color: var(--accent);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.mail-link:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
  text-shadow: 0 0 10px var(--accent-glow);
}

/* ========== 📱 АДАПТИВНОСТЬ 📱 ========== */
@media (max-width: 768px) {
  .fund-grid {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .fund-logo {
    order: -1;
    margin-bottom: 20px;
  }
  .hero-title, .title-divider {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }
  .lead, .body-text, .contacts, .support-note {
    text-align: center;
  }
}

@media (max-width: 576px) {
  .container {
    margin: 16px auto;
    padding: 8px;
  }
  .section-card {
    padding: 24px;
  }
  .hero-title {
    font-size: 24px;
  }
  .lead, .body-text {
    font-size: 16px;
  }
  .numbered-list li {
    padding-left: 0;
    text-align: center;
  }
  .numbered-list li::before {
    position: static;
    display: block;
    margin: 0 auto 12px;
  }
  .accent-list li {
    flex-direction: column;
    text-align: center;
  }
}
</style>